import { styled } from "@mui/material/styles";

import { ListItemButton, ListItemButtonProps } from "@mui/material";
import { ListItemIcon, ListItemIconProps } from "@mui/material";
import { ListItemText, ListItemTextProps } from "@mui/material";

interface InputListItemButtonProps extends ListItemButtonProps {
  active: number;
  isSudan?: boolean;
}

interface InputListItemIconProps extends ListItemIconProps {
  active: number;
  isSudan?: boolean;
}

interface InputListItemTextProps extends ListItemTextProps {
  active: number;
  isSudan?: boolean;
}
interface DotProps {
  active: number;
  isSudan?: boolean;
}

export const StyledListItemButton = styled(
  ListItemButton
)<InputListItemButtonProps>(({ theme, active, isSudan }) => ({
  textDecoration: "none",
  "&:hover, &:focus": {
    backgroundColor: theme.palette.background.default,
  },
  // "& svg": {
  //   marginRight: 1,
  // },
  ...(active && {
    color: isSudan ? theme.palette.warning.main : theme.palette.primary.main,
  }),
  color: theme.palette.text.primary,
}));

export const StyledListItemIcon = styled(ListItemIcon)<InputListItemIconProps>(
  ({ theme, active, isSudan }) => ({
    marginRight: theme.spacing(1),
    color: isSudan ? theme.palette.info.main : theme.palette.secondary.main,
    "&:hover, &:focus": {
      color: isSudan ? theme.palette.warning.main : theme.palette.primary.main,
    },
    ...(active && {
      color: isSudan ? theme.palette.warning.main : theme.palette.primary.main,
    }),
    transition: theme.transitions.create("color"),
    minWidth: 64,
    display: "flex",
    justifyContent: "center",
  })
);

export const StyledListItemText = styled(ListItemText)<InputListItemTextProps>(
  ({ theme, active, isSudan }) => ({
    padding: 0,
    color: isSudan ? theme.palette.warning.main : theme.palette.primary.main,
    "&:hover, &:focus": {
      color: isSudan ? theme.palette.info.main : theme.palette.secondary.main,
    },
    ...(active && {
      color: isSudan ? theme.palette.info.main : theme.palette.secondary.main,
    }),
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
  })
);

export const Dot = styled("div")<DotProps>(({ theme, active }) => ({
  width: 11,
  height: 11,
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "50%",
  transition: theme.transitions.create("background-color"),
  "&:hover, &:focus": {
    backgroundColor: theme.palette.primary.main,
  },
  ...(active && {
    backgroundColor: theme.palette.primary.main,
  }),
}));
